const Loader = () => {
    return (
        <div title='Loader' className="spinner-grow text-success" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}

export default Loader